import { Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '@/components/auth/protected-route';
import { AppLayout } from '@/components/navigation/app-layout';
import { ProjectLayout } from '@/components/navigation/project-layout';
import { PlaybookDefinitionsPage } from '@/pages/admin/playbook-definitions-page';
import { ProjectAdminPage } from '@/pages/admin/project-admin-page';
import { AuthCallbackPage } from '@/pages/auth/auth-callback-page';
import { DashboardPage } from '@/pages/dashboard/dashboard-page';
import { NotFoundPage } from '@/pages/not-found/not-found-page';
import { NotificationsPage } from '@/pages/notifications/notifications-page';
import { CreatePrPage } from '@/pages/pr/create-pr-page';
import { PrDetailPage } from '@/pages/pr/pr-detail-page';
import { ProjectActivityPage } from '@/pages/projects/project-activity-page';
import { ProjectArtifactsPage } from '@/pages/projects/project-artifacts-page';
import { ProjectConfigurePage } from '@/pages/projects/project-configure-page';
import { ProjectDatabasesPage } from '@/pages/projects/project-databases-page';
import { ProjectDeployPage } from '@/pages/projects/project-deploy-page';
import { ProjectDownloadPage } from '@/pages/projects/project-download-page';
import { ProjectHistoryPage } from '@/pages/projects/project-history-page';
import { ProjectInventoryPage } from '@/pages/projects/project-inventory-page';
import { ProjectListPage } from '@/pages/projects/project-list-page';
import { ProjectPlaybooksPage } from '@/pages/projects/project-playbooks-page';
import { ProjectReviewPage } from '@/pages/projects/project-review-page';
import { ProjectServersPage } from '@/pages/projects/project-servers-page';
import { ProjectSettingsPage } from '@/pages/projects/project-settings-page';
import { ProjectSlackPage } from '@/pages/projects/project-slack-page';
import { ProjectStatePage } from '@/pages/projects/project-state-page';
import { RepoDetailPage } from '@/pages/repos/repo-detail-page';
import { SettingsPage } from '@/pages/settings/settings-page';

export function AppRoutes() {
  return (
    <Routes>
      {/* Auth callback is outside the main layout and not protected */}
      <Route path="/auth/callback" element={<AuthCallbackPage />} />

      {/* All other routes require authentication */}
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/repos/:name" element={<RepoDetailPage />} />
        <Route path="/repos/:name/prs/:id" element={<PrDetailPage />} />
        <Route path="/repos/:name/prs/new" element={<CreatePrPage />} />
        <Route path="/projects" element={<ProjectListPage />} />

        {/* Project sub-pages with secondary sidebar */}
        <Route path="/projects/:projectKey" element={<ProjectLayout />}>
          <Route index element={<ProjectActivityPage />} />
          <Route path="review" element={<ProjectReviewPage />} />
          <Route path="download" element={<ProjectDownloadPage />} />
          <Route path="artifacts" element={<ProjectArtifactsPage />} />
          <Route path="state" element={<ProjectStatePage />} />
          <Route path="servers" element={<ProjectServersPage />} />
          <Route path="deploy" element={<ProjectDeployPage />} />
          <Route path="configure" element={<ProjectConfigurePage />} />
          <Route path="databases" element={<ProjectDatabasesPage />} />
          <Route path="history" element={<ProjectHistoryPage />} />
          <Route path="inventory" element={<ProjectInventoryPage />} />
          <Route path="settings" element={<ProjectSettingsPage />} />
          <Route path="admin/slack" element={<ProjectSlackPage />} />
          <Route path="admin/playbooks" element={<ProjectPlaybooksPage />} />
          <Route path="repos/:repoName" element={<RepoDetailPage />} />
          <Route path="repos/:repoName/prs/new" element={<CreatePrPage />} />
          <Route path="repos/:repoName/prs/:id" element={<PrDetailPage />} />
        </Route>

        <Route path="/admin/projects" element={<ProjectAdminPage />} />
        <Route path="/admin/playbook-definitions" element={<PlaybookDefinitionsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
